import { CasperIconComponent, Flex, Heading, Text } from "@caspeco/casper-ui-library";
import {
	ThemeSpaceVariable,
	ThemeIconSizeVariable,
	ThemeColorVariable,
	ThemeFontSizeVariable,
} from "@caspeco/casper-ui-library";
import { type JSX } from "react";
import { t } from "i18next";

type EmptyStateProps = {
	icon: CasperIconComponent;
	title: string;
	text: string;
	error?: string;
	buttons?: JSX.Element[];
	testId?: string;
};

const EmptyState = (props: EmptyStateProps) => {
	const { icon: IconComponent, title, text, buttons, error, testId } = props;
	return (
		<Flex
			direction={"column"}
			justify={"space-between"}
			gap={ThemeSpaceVariable.Medium}
			h="100%"
			data-testid={testId}
		>
			<Flex
				alignItems={"center"}
				direction={"column"}
				gap={ThemeSpaceVariable.Medium}
				justify={"space-between"}
			>
				<IconComponent size={ThemeIconSizeVariable.X3Large} color={ThemeColorVariable.OnBackgroundBorder} />
				<Heading as="h3" fontSize={ThemeFontSizeVariable.Large}>
					{t(title)}
				</Heading>
				<Text textAlign={"center"} data-testid="empty-state-text">
					{t(text)}
				</Text>
				{error && <Text>Error: {error}</Text>}
			</Flex>
			<Flex direction={"column"} gap={ThemeSpaceVariable.Medium}>
				{buttons && buttons.map((b) => b)}
			</Flex>
		</Flex>
	);
};

export default EmptyState;
